import PropTypes from 'prop-types';

const propType = {
  level: PropTypes.number,
  name: PropTypes.string,
  icon: PropTypes.string,
};

const defaultProp = {
  level: 0,
  name: '',
  icon: '',
};

export default { propType, defaultProp };
